function isObject(value) {
  return typeof value === "object" && !!value && value.toString() === "[object Object]";
}
export {
  isObject as default
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
